//i18n.js 国际化配置文件
import Vue from 'vue'
import VueI18n from 'vue-i18n'
// import en from 'element-ui/lib/locale/lang/en'
// import locale from 'element-ui/lib/locale'
// locale.use(en)
Vue.use(VueI18n)
const i18n = new VueI18n({
    locale: 'zh',
    messages: {
        zh: require('@/locale/zh.json'),
        en: require('@/locale/en.json'),
    },
})
export default i18n
